module.exports = __webpack_public_path__ + "media/components/resources/show/daily-limit-join-pro-modal/img/guage-icon-55dd5a91c6be322d254e6b48d5a2cc5f.svg";